import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import Svg, { Path } from '@dbk/ui-svg';
import { PALETTE } from '../../../constants'

function DbLogo(props) {
  const {
    ...svgProps
  } = props;

  return(
    <Svg {...svgProps} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" >
      <Path d="M7.83913 7.83715V48.1609H48.1589V7.83715H7.83913ZM0 0H56V56H0V0ZM12.3198 42.5601L33.6008 13.4419H43.6802L22.3992 42.5601H12.3198Z" fill={PALETTE.secondaryActive}/>
    </Svg>
  )
}

DbLogo.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

DbLogo.defaultProps = {
  height: 60,
  width: 60,
}

export default pure(DbLogo);